
import { claimNextdayTreasure, getNextdayTreasureReward } from '@/api/activity'
import { useUserStore } from '@/stores/user'

export function useNextdayTreasureService(
    showError: (msg: string) => void,
    showSuccess: (msg: string) => void,
    loadingRef: any,
) {

    const userStore = useUserStore()

    // Get Rewards API
    const fetchRewardInfo = async () => {
        loadingRef.value.open()
        try {
            const res = await getNextdayTreasureReward()
            loadingRef.value.close()
            return {
                rewardAmount: res.data?.rewardAmount || 0,
                rewardTimes: res.data?.rechargeBonusTimes || 0,
                rewardMode: res.data?.rewardMode || '',
                rewardType: res.data?.rewardType || 1,
                fixedRechargeConfigs: res.data?.fixedRechargeConfigs || []
            }
        } catch (err: any) {
            if (err.code !== 401) showError(err)
            loadingRef.value.close()
            throw err
        }
    }

    // Claim Reward API
    const claimReward = async () => {
        loadingRef.value.open()
        try {
            const res = await claimNextdayTreasure({ uid: userStore.id })
            showSuccess(res.msg)
            userStore.getInfo()
            loadingRef.value.close()
            return res
        } catch (err: any) {
            if (err.code !== 401) showError(err)
            loadingRef.value.close()
            throw err
        }
    }

    return {
        fetchRewardInfo,
        claimReward
    }
}